import { Button } from './Button';

/**
 * The shared error state for a failed resource read: a message + a retry button.
 * Every screen that loads through useApiResource renders this on `status === 'error'`,
 * so the "stuck forever on a spinner" failure mode is replaced by one consistent,
 * recoverable UI across the whole app.
 */
export function ErrorRetry({ error, onRetry }: { error?: string | null; onRetry: () => void }) {
  return (
    <div className="banner banner-err" role="alert">
      {error ?? 'خطا در بارگذاری اطلاعات'}
      <div className="row" style={{ marginTop: 10 }}>
        <Button onClick={onRetry}>تلاش دوباره</Button>
      </div>
    </div>
  );
}
